// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Calculate/components/CalculateLoads/styles.scss
// module id = 1251
// module chunks = 0